import {IoCopyright, IoReusableElement} from "@app/layout/components/io-reusable-components/element-models";


export class IoReusableUtils  {
  static readonly createElementFromReusableData = (tag: string, props = {}, kids: any = []) => {
    const createdElement = Object.assign(document.createElement(tag), props);
    for (const child of [].concat(kids)) createdElement.append(child);
    return createdElement;
  };

  static buildMenu(items: IoCopyright[], className?: string) {
    const ul = this.createElementFromReusableData('ul', className ? { className } : {});
    for (const item of items) {
      const htmlAnchorElement = this.createElementFromReusableData('a', { href: item.url, target: item.target || '_self', textContent: item.title }) as HTMLAnchorElement;
      if (item.target === '_blank') htmlAnchorElement.rel = 'noopener';
      const li = this.createElementFromReusableData('li', {}, htmlAnchorElement);
      if (item.children && item.children.length) {
        li.classList.add('has-children');
        li.append(this.buildMenu(item.children));
      }
      ul.append(li);
    }
    return ul;
  }

  static applyTokens(tokens: IoReusableElement) {
    const colors = tokens.branding.colors || {};
    const root = document.documentElement.style;
    if (colors.primary) root.setProperty('--io-primary', colors.primary);
    if (colors.midnight_blue) root.setProperty('--io-midnight', colors.midnight_blue);
    if (colors.deep_blue) root.setProperty('--io-deep', colors.deep_blue);
    if (colors.accent_rich_blue) root.setProperty('--io-accent', colors.accent_rich_blue);
    if (colors.water) root.setProperty('--io-water', colors.water);
    if (colors.dark_grey) root.setProperty('--io-grey', colors.dark_grey);
    if (tokens.branding.font_url) {
      document.head.append(this.createElementFromReusableData('link', { rel: 'stylesheet', href: tokens.branding.font_url }));
      root.setProperty('--io-font', '"' + tokens.branding.font_family + '", system-ui, sans-serif');
    }
  }

  readonly status = document.getElementById('status');
}
